import { gql } from "@apollo/client";


export const GET_AUTH_GROUP = gql`
    query userAuthGroup {
        userAuthGroup {
            name
        }
    }
`